import { render, staticRenderFns } from "./UserActivateButton.vue?vue&type=template&id=04276fea&"
import script from "./UserActivateButton.vue?vue&type=script&lang=js&"
export * from "./UserActivateButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports